export default "__VITE_ASSET__puLwn74M__"